export default __webpack_public_path__ + "static/media/ClockLarge.6f5d915f.svg";